import { render, staticRenderFns } from "./DingdingGroup.vue?vue&type=template&id=79bdc91b&scoped=true"
import script from "./DingdingGroup.vue?vue&type=script&lang=js"
export * from "./DingdingGroup.vue?vue&type=script&lang=js"
import style0 from "./DingdingGroup.vue?vue&type=style&index=0&id=79bdc91b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bdc91b",
  null
  
)

export default component.exports